import React from 'react';

import {
  Screen,
  Container,
  Polygon,
  Wrapper,
  Title,
  Description,
  Info,
  Progress,
  Row,
  Icon,
  Text,
} from './styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Button from '../../components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { persistor } from '../../store';
import { endSession } from '../../store/analytic/actions';

interface IPopover {
  open: boolean;
  close: Function;
}

function Popover({ open, close }: IPopover) {
  const handler = (e: any) => {
    e.target.id === 'background' && close();
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const userName = useSelector(
    (state: ApplicationState) => state.auth.user?.nome
  );
  const handleLogout = () => {
    dispatch(endSession.request());
    window.localStorage.removeItem('acceptedCookies');
    persistor.purge();
    history.replace('/');
  };
  const theme = useTheme();

  const handlerProfile = () => {
    close();
    history.push('/perfil');
  };
  const percentage = useSelector(
    (state: ApplicationState) => state.auth.percentage
  );

  return (
    <Screen id='background' open={open} onClick={(e) => handler(e)}>
      <Container>
        <Polygon />
        <Wrapper id='popover'>
          <Info>
            <Title>Olá, {userName}</Title>
            <Description>
              Seu perfil está <strong>{percentage}%</strong> completo.{' '}
              {percentage !== 100 &&
                'Preencha os dados que estão faltando para alcançar 100%.'}
            </Description>
            <Row>
              <Button
                color={'primary'}
                borderRadios='4'
                onClick={handlerProfile}
                paddingVertical={1}
              >
                <Text>
                  {percentage === 100 ? 'Editar Perfil' : 'Completar Perfil'}
                </Text>
              </Button>
              <span /> {/* Não remover esse span */}
              <Button
                color={'secondary'}
                borderRadios='4'
                onClick={handleLogout}
                paddingVertical={1}
              >
                <Row>
                  <Icon>
                    <FontAwesomeIcon icon={faSignOutAlt} />
                  </Icon>
                  <Text>Sair</Text>
                </Row>
              </Button>
            </Row>
          </Info>
          <Progress>
            {percentage !== 100 ? (
              <CircularProgressbar
                value={percentage}
                strokeWidth={8}
                text={`${percentage}%`}
                styles={buildStyles({
                  textColor: theme.colors.primary,
                  textSize: 24,
                  pathColor: theme.colors.primary,
                  trailColor: theme.colors.primaryLight,
                })}
              />
            ) : (
              <div className='complete'>{percentage}%</div>
            )}
          </Progress>
        </Wrapper>
      </Container>
    </Screen>
  );
}

export default Popover;
